module.exports = "<div id=\"chat-body\" class=\"chat-body custom-scroll\">\r\n  <ul>\r\n    <li class=\"message\" *ngFor=\"let message of messages\">\r\n      <img class=\"message-picture online\" src=\"{{message.user.picture}}\">\r\n\r\n      <div class=\"message-text\">\r\n        <time>\r\n          {{message.date | moment : 'YYYY-MM-DD'}}\r\n        </time>\r\n        <a (click)=\"messageTo(message.user)\" class=\"username\">{{message.user.username}}</a>\r\n        <div [innerHTML]=\"message.body\"></div>\r\n\r\n      </div>\r\n    </li>\r\n  </ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/chat/chat/chat-body.component.html
// module id = 894
// module chunks = 85